// @flow
import * as React from 'react';
import { TextInput as GrommetInput, Stack, Box } from 'grommet';
import { triggerNativeEvent } from 'speed-js-react-web/src/utils/events';
import styled from 'styled-components';
import FieldWrapper from '../grommet2/forms/fields/FieldWrapper';
import StyledCloseButton from '../grommet2/forms/fields/StyledCloseButton';

const StyledBox = styled(Box)`
    position: absolute;
    right: 10px
`;

type Props = {
    onChange: (e: SyntheticFocusEvent<HTMLInputElement>) => void,
    onBlur?: (e: SyntheticFocusEvent<any>) => void,
    value: any,
    name: string,
    disabled?: boolean,
    min_value?: number,
    max_value?: number,
    step?: number,
}

/**
 * Number inpit component used with the coordinates input to provide coordinates validation
 * @param {Props} props component props
 * @returns {JSX.Element} react node
 * @constructor
 */
const NumberInput = (props: Props): React.Node => {
    const {
        disabled,
        name,
        onChange,
        onBlur,
        value,
        min_value: minValue,
        max_value: maxValue,
        step,
    } = props;

    const inputRef = React.useRef(null);

    React.useEffect(() => {
        if (value !== null && value !== '' && value < minValue) {
            inputRef.current.value = minValue;
            onChange({ target: inputRef.current });
        } else if (value !== null && value !== '' && value > maxValue) {
            inputRef.current.value = maxValue;
            onChange({ target: inputRef.current });
        }
    }, [value, minValue, maxValue, onChange]);

    const onClear = (e) => {
        e.target.value = '';
        onChange(name, 'clear');
        triggerNativeEvent(inputRef.current, 'change');
    };

    const id = ((maxValue === 90 && 'x') || (maxValue === 180 ? 'y' : ''));

    return (
        <FieldWrapper
            name={name}
        >
            <Stack anchor="right">
                <GrommetInput
                    type="number"
                    name={name}
                    ref={inputRef}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value || ''}
                    id={`id-${name}-${id}`}
                    disabled={disabled}
                    min={minValue}
                    max={maxValue}
                    step={step}
                />
                {value && !disabled && (
                    <StyledBox style={{ top: -16, right: 32 }}>
                        <StyledCloseButton onClick={onClear} plain />
                    </StyledBox>
                )}
            </Stack>
        </FieldWrapper>
    );
};

export default NumberInput;

NumberInput.defaultProps = {
    onBlur: () => null,
    value: '',
    name: '',
    disabled: false,
    min_value: Number.MIN_VALUE,
    max_value: Number.MAX_VALUE,
    step: undefined,
};
